import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { ListCardsResponseWithProjectName } from "tng-address-collection-shared/types/apiTypes.ts";
import { queryKeys } from "./queryKeys.ts";

export const useDeleteCardFromProjectCache = (projectId: string) => {
  const queryClient = useQueryClient();

  return useCallback(
    (id: string) => {
      queryClient.setQueryData<ListCardsResponseWithProjectName>(
        queryKeys.cardsInProject(projectId),
        (old) =>
          old && {
            ...old,
            items: old.items.filter((card) => card.id !== id),
          },
      );
    },
    [projectId, queryClient],
  );
};
